export const internVacancyTranslations = {
  lv: {
    title: 'Vakances',
    description:
      'Atvērtās vakances, kas atbilst tavas prakses kategorijām. Katrai vakancei pieteikumu var nosūtīt vienreiz; to var atsaukt lapā „Mani pieteikumi”.',
    count_zero: '{{count}} vakanču',
    count_one: '{{count}} vakance',
    count_other: '{{count}} vakances',
    search: 'Meklēt pēc nosaukuma, organizācijas, adreses, apraksta',
    applied: 'Pieteikts',
    columns: {
      title: 'Nosaukums',
      orgname: 'Organizācija',
      address: 'Adrese',
      workplace: 'Darba vieta',
      categories: 'Kategorijas',
      priority: 'Publicēts',
      applied: 'Mans pieteikums',
    },
    workplace: {
      OnSite: 'Klātienē',
      Remote: 'Attālināti',
      Mixed: 'Jaukts',
      Dynamic: 'Dinamisks',
      NotSet: 'Nav norādīts',
    },
    empty: {
      all: 'Nav atvērtu vakanču',
      notApplied: 'Nav vakanču bez tava pieteikuma',
      applied: 'Nav vakanču ar tavu pieteikumu',
    },
    filters: {
      button: 'Filtri',
      title: 'Filtri',
      show: 'Rādīt',
      shows: {
        all: 'Visas vakances',
        notApplied: 'Bez mana pieteikuma',
        applied: 'Ar manu pieteikumu',
      },
      clear: 'Notīrīt',
      apply: 'Filtrēt',
      active: 'Aktīvie filtri',
      remove: 'Noņemt filtru {{filter}}',
    },
    actions: {
      menu: 'Darbības',
      apply: 'Pieteikties',
      withdraw: 'Atsaukt pieteikumu',
    },
    apply: {
      title: 'Pieteikums vakancei',
      motivation: 'Motivācija',
      motivationPlaceholder: 'Īsi apraksti, kāpēc vēlies šo prakses vietu (nav obligāti)',
      submit: 'Nosūtīt pieteikumu',
    },
    withdraw: {
      confirm: 'Atsaukt pieteikumu vakancei „{{title}}”?',
      submit: 'Atsaukt',
      noVacancy: 'Pieteikums nav saistīts ar vakanci',
    },
    messages: {
      applied: 'Pieteikums nosūtīts',
      withdrawn: 'Pieteikums atsaukts',
      failed: 'Neizdevās izpildīt darbību',
    },
  },
  en: {
    title: 'Vacancies',
    description:
      'Open vacancies that match the categories of your internship. You can apply to each vacancy once and withdraw the application on the "My applications" page.',
    count_one: '{{count}} vacancy',
    count_other: '{{count}} vacancies',
    search: 'Search by title, organization, address, description',
    applied: 'Applied',
    columns: {
      title: 'Title',
      orgname: 'Organization',
      address: 'Address',
      workplace: 'Workplace',
      categories: 'Categories',
      priority: 'Published',
      applied: 'My application',
    },
    workplace: {
      OnSite: 'On site',
      Remote: 'Remote',
      Mixed: 'Mixed',
      Dynamic: 'Dynamic',
      NotSet: 'Not specified',
    },
    empty: {
      all: 'No open vacancies',
      notApplied: 'No vacancies without your application',
      applied: 'No vacancies with your application',
    },
    filters: {
      button: 'Filters',
      title: 'Filters',
      show: 'Show',
      shows: {
        all: 'All vacancies',
        notApplied: 'Without my application',
        applied: 'With my application',
      },
      clear: 'Clear',
      apply: 'Filter',
      active: 'Active filters',
      remove: 'Remove filter {{filter}}',
    },
    actions: {
      menu: 'Actions',
      apply: 'Apply',
      withdraw: 'Withdraw application',
    },
    apply: {
      title: 'Application for a vacancy',
      motivation: 'Motivation',
      motivationPlaceholder: 'Briefly describe why you want this internship place (optional)',
      submit: 'Send application',
    },
    withdraw: {
      confirm: 'Withdraw the application for "{{title}}"?',
      submit: 'Withdraw',
      noVacancy: 'The application is not linked to a vacancy',
    },
    messages: {
      applied: 'Application sent',
      withdrawn: 'Application withdrawn',
      failed: 'The action failed',
    },
  },
}
